import React from "react";
import PathOption from "../PathOption";
import PathOptionGroup from "../PathOptionGroup";

function PathBuilderOptionsSeedSigner({ t, options, handleOptionChange, osSelected }) {
  return (
    <PathOptionGroup title={t("pathBuilder.categories.seedsigner")} className="seedsigner-multi-column">
      <PathOption
        id="buy-seedsigner"
        label={t("pathBuilder.checkboxes.buySeedSigner")}
        checked={options.buySeedSigner}
        onChange={() => handleOptionChange("buySeedSigner")}
        disabled={!osSelected || options.buyHat || options.buildHat || options.integrateHat || options.print3DSeedSignerHatBox}
      />
      <PathOption
        id="download-install-balena"
        label={t("pathBuilder.checkboxes.downloadInstallBalena")}
        checked={options.downloadInstallBalena}
        onChange={() => handleOptionChange("downloadInstallBalena")}
        disabled={!osSelected}
      />
      <div className="path-option-subgroup">
        <h4 className="path-option-subgroup-title">{t("pathBuilder.checkboxes.getSeedSignerImage")}</h4>
        <div className="path-option-subgroup-options">
          <div>
            <PathOption
              id="flash-seedsigner-release"
              label={t("pathBuilder.checkboxes.useRelease")}
              checked={options.flashSeedSignerUseRelease}
              onChange={() => handleOptionChange("flashSeedSignerUseRelease")}
              disabled={!osSelected || options.flashSeedSignerCompile}
            />
            <div className="path-option-nested">
              <PathOption
                id="verify-signature"
                label={t("pathBuilder.checkboxes.verifySignature")}
                checked={options.verifySignature}
                onChange={() => handleOptionChange("verifySignature")}
                disabled={!osSelected || !options.flashSeedSignerUseRelease}
              />
              <PathOption
                id="verify-bitcoin-signature"
                label={t("pathBuilder.checkboxes.verifyBitcoinSignature")}
                checked={options.verifyBitcoinSignature}
                onChange={() => handleOptionChange("verifyBitcoinSignature")}
                disabled={!osSelected || !options.flashSeedSignerUseRelease || !options.verifySignature}
              />
            </div>
          </div>
          <PathOption
            id="flash-seedsigner-compile"
            label={t("pathBuilder.checkboxes.compile")}
            checked={options.flashSeedSignerCompile}
            onChange={() => handleOptionChange("flashSeedSignerCompile")}
            disabled={!osSelected || options.flashSeedSignerUseRelease}
          />
        </div>
      </div>
      <PathOption
        id="assemble-seedsigner"
        label={t("pathBuilder.checkboxes.assembleSeedSigner")}
        checked={options.assembleSeedSigner}
        onChange={() => handleOptionChange("assembleSeedSigner")}
        disabled={!osSelected}
      />
      <PathOption
        id="flash-seedsigner"
        label={t("pathBuilder.checkboxes.flashSeedSigner")}
        checked={options.flashSeedSigner}
        onChange={() => handleOptionChange("flashSeedSigner")}
        disabled={!osSelected || (!options.flashSeedSignerUseRelease && !options.flashSeedSignerCompile)}
      />
      <PathOption
        id="configure-seedsigner-settings"
        label={t("pathBuilder.checkboxes.configureSeedSignerSettings")}
        checked={options.configureSeedSignerSettings}
        onChange={() => handleOptionChange("configureSeedSignerSettings")}
        disabled={!osSelected}
      />
    </PathOptionGroup>
  );
}

export default PathBuilderOptionsSeedSigner;
